import { Component, Element, h, Prop, Host } from '@stencil/core';

@Component({
  tag: 'aha-comment-button',
  styleUrl: 'aha-comment-button.css',
  shadow: true,
})
export class AhaCommentButton {
  @Element() host!: HTMLAhaCommentButtonElement;

  /** Whether to display a line. */
  @Prop() line: boolean = false;

  render() {
    return (
      <Host>
        <span class="aha-comment-button">
          <span class="aha-comment-button__body">
            <slot />
          </span>
          {this.line && <span class="aha-comment-button__line">|</span>}
        </span>
      </Host>
    );
  }
}
